import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCompany } from "../homeSlice";
import {
  driversAccessRequestsListAsync,
  selectDriverAccessRequestsList,
  selectDriverAccessRequestsListStatus,
} from "../drivers/driversSlice";
import type { PageTasks } from "./tasksSummary";

export const useDriversTasks = (): PageTasks => {
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const driversAccessRequestsListStatus = useAppSelector(
    selectDriverAccessRequestsListStatus,
  );
  const driversAccessRequestsList = useAppSelector(
    selectDriverAccessRequestsList,
  );

  useEffect(() => {
    if (company && driversAccessRequestsListStatus === "idle") {
      void dispatch(driversAccessRequestsListAsync(company.uuid));
    }
  }, [dispatch, company, driversAccessRequestsListStatus]);

  return { count: driversAccessRequestsList.length, tasks: [] };
};
